import { useContext } from 'react';

import { AiSocketContext } from '../context/AiSocketContext';

/** Хук для доступа к глобальному AiSocket из любой точки приложения. */
export const useAiSocket = () => {
  const aiSocket = useContext(AiSocketContext);
  if (!aiSocket) {
    throw new Error('useAiSocket must be used within AiSocketProvider');
  }
  return aiSocket;
};
